import React from 'react';
import MobileAdvertiserHeader from "./MobileAdvertiserHeader";

const MobileDefaultLayout = ({ children }) => {
  return (
    <div className="mobile-default-layout">
      <MobileAdvertiserHeader/>
      <div className="mobile-default-layout-content">
        {children}
      </div>
    </div>
  );
};

export default MobileDefaultLayout;
